/**
 * ⚠️ WARNING ⚠️
 * This file is automatically generated, do not edit it manually",
 */

import React from "react";

import { buildingWireless2Duocolor } from "../assets/building-wireless-2-duocolor";
import {
  type StaticIllustrativeBaseIconProps,
  StaticIllustrativeIcon,
} from "../static-illustrative-icon";

export const IllustrativeIconBuildingWireless2Duocolor = (props: StaticIllustrativeBaseIconProps) => (
  <StaticIllustrativeIcon {...props} svg={buildingWireless2Duocolor.svg} />
);

IllustrativeIconBuildingWireless2Duocolor.displayName = "IllustrativeIconBuildingWireless2Duocolor";
